<div class="main_content">
    <app-breadcrumb></app-breadcrumb>

    <div #page_section class="page_main_sec">
        <div class="UploadData_main_sec">
            <div class="container-fluid">
            </div>
        </div>

        <div class="tab-content mt-20">
            <div>
                <div class="table_card_sec mb_0">
                    <div class="table scroll_table">
                        <div class="row advance-search-wrp">

                            <div class="col-lg-3">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <mat-label for="work_item_type">Work Item Type</mat-label>
                                    <mat-select [(ngModel)]="selectedDocType"
                                        (selectionChange)="getAdvanceSearchFields()" id="work_item_type">
                                        <mat-option [value]="option.value" *ngFor="let option of docTypeList">
                                            {{ option.text }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field appearance="legacy" [style.width.%]="100">
                                    <mat-label for="urn">URN</mat-label><input matInput placeholder="URN" id="urn"
                                        [(ngModel)]="lstURN">
                                </mat-form-field>
                            </div>
                            <div class="col-lg-3">
                                <app-dropdown-multiselect #ddlProcessmultiselect [labelText]="'Queue'"
                                    [lstDropdownOption]="lstProcess" [allSelected]="true">
                                </app-dropdown-multiselect>
                            </div>
                            <div class="col-lg-3">
                                <app-dropdown-multiselect #ddlPriority [labelText]="'Priority'"
                                    [lstDropdownOption]="lstPriority" [allSelected]="true">
                                </app-dropdown-multiselect>
                            </div>
                            <div class="col-lg-3">
                                <mat-form-field [style.width.%]="100">
                                    <mat-label for="invoice_date_range">Invoice Date Range</mat-label>
                                    <mat-date-range-input [min]="commonService.minDate" [rangePicker]="picker"
                                        [formGroup]="invoiceCreationDateRange" id="invoice_date_range">
                                        <input matStartDate formControlName="start_date" #startdate
                                            placeholder="Start Date" [max]="maxDate"
                                            (dateChange)="onInvoiceCreationDateChanges()">
                                        <input matEndDate formControlName="end_date" #endDate placeholder="End Date"
                                            [max]="maxDate" (dateChange)="onInvoiceCreationDateChanges()">
                                    </mat-date-range-input>
                                    <button *ngIf="isDateRangeHasValue" mat-button matSuffix mat-icon-button
                                        (click)="resetInvoiceCreationDateRange()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                </mat-form-field>


                            </div>

                            <div *ngFor="let field of advanceSearchFields" [ngSwitch]="field.control_type | lowercase"
                                class="col-lg-{{ field.control_type == 'TEXTAREA' ? 6 : 3 }}">

                                <mat-form-field *ngSwitchCase="'textbox'" [style.width.%]="100">
                                    <input matInput [placeholder]="field.field_name" [(ngModel)]="field.search_value"
                                        [type]="field.value_type"
                                        (change)="field.search_value=setDecimalPlaces(field.search_value,field.precision_point,field.validation_type);" />
                                </mat-form-field>

                                <mat-form-field appearance="legacy" *ngSwitchCase="'dropdown'" [style.width.%]="100">
                                    <mat-label for="{field.field_name}">{{ field.field_name }}</mat-label>
                                    <mat-select [(ngModel)]="field.search_value" (click)="searchText.focus()"
                                        (focus)="searchText.focus()" (closed)="searchText.value=''"
                                        [id]="field.field_name">
                                        <input type="search" (keydown)="$event.stopPropagation()" #searchText
                                            autocomplete="off" class="mat-select-search"
                                            placeholder="Search {{field.field_name}}">
                                        <mat-option [value]="option.id"
                                            *ngFor="let option of field.options| listFilter:{'name':searchText.value}">
                                            {{ option.name }}
                                        </mat-option>
                                    </mat-select>
                                    <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix mat-icon-button
                                        (click)="
                      $event.stopPropagation();openFilterFieldMagnifySearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields)">
                                        <mat-icon title="search">search</mat-icon>
                                    </button>
                                </mat-form-field>

                                <mat-form-field *ngSwitchCase="'date'" [style.width.%]="100">
                                    <input matInput readonly [(ngModel)]="field.search_value" [matDatepicker]="picker"
                                        [placeholder]="field.field_name" [min]="commonService.minDate">
                                    <button *ngIf="field.search_value!=''" mat-button matSuffix mat-icon-button
                                        (click)="field.search_value=''">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field *ngSwitchCase="'textarea'" [style.width.%]="100">
                                    <textarea matInput [placeholder]="field.field_name" [(ngModel)]="field.search_value"
                                        rows="1"></textarea>
                                </mat-form-field>
                            </div>

                            <div class="col-md-12 btn-opensearch">
                                <button type="button" class="btncss me-2 btn_primary" (click)="getOpenSearchData();">
                                    Search
                                </button>
                                <button type="button" class="btncss me-2 btn_secondary" (click)="ClearOpenSearch()">
                                    Clear
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="grid_panel">
                <app-basic-gridview *ngIf="advanceSearchGridData.length > 0" [lstData]="advanceSearchGridData"
                    [columnsToHide]="advanceSearchColumnsToHide" [gridTitle]="'Filtered Data'"
                    [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                    [showPagination]="true" (cellClickEvent)="advanceSearchCellClick($event)"
                    [exportToExcelFileName]="'Open-Search-Result'"
                    [columnsToExcludeFromExport]="['DOCUMENT_DETAIL_ID']">
                </app-basic-gridview>
            </div>

            <div>
                <div [formGroup]="frmInvoice" *ngIf="frmInvoice">
                    <div class="table_card_sec mb_0" *ngIf="lstSection.length>0">
                        <div class="row">
                            <div class="form-control-sec">
                                <div *ngFor="let section of lstSection">
                                    <div class="row">
                                        <h6 class="advance_search_title">
                                            <span class="main_tab_title">{{section.SECTION_NAME}}</span>
                                        </h6>
                                    </div>
                                    <div class="row">
                                        <div *ngFor="let field of section.FIELDS_DETAIL" [ngSwitch]="field.control_type"
                                            class="col-lg-{{ field.control_type == 'TEXTAREA' ? 6 : 3 }}">
                                            <mat-form-field *ngSwitchCase="'TEXTBOX'" [style.width.%]="100">
                                                <mat-label>
                                                    {{ field.field_name }}
                                                    <span *ngIf="field.is_mandatory == 1"
                                                        class="field-mandatory">*</span>
                                                    <span
                                                        *ngIf="field.validation_type == 'NUMERIC' &&  field.precision_point<=0"
                                                        class="field-numeric">#</span>
                                                    <span
                                                        *ngIf="(field.validation_type == 'NUMERIC' || field.validation_type == 'AMOUNT') &&  field.precision_point>0 "
                                                        class="field-decimal">##</span>
                                                </mat-label>

                                                <input matInput
                                                    *ngIf="field.value_type=='text' && field.validation_type != 'AMOUNT'"
                                                    [type]="field.value_type" [formControlName]="field.db_column_name"
                                                    (keydown.enter)="submitInvoice()"
                                                    (change)="changeTextFieldValue(field)"
                                                    (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                                                <input matInput *ngIf="field.value_type=='number'" class="text-end"
                                                    (keypress)="onTextBoxKeyPressEvent($event,field)"
                                                    [type]="field.value_type" [formControlName]="field.db_column_name"
                                                    (keydown.enter)="submitInvoice()"
                                                    (change)="changeTextFieldValue(field)"
                                                    (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                                                <input matInput *ngIf="field.validation_type == 'AMOUNT'"
                                                    class="text-end" (blur)="commonService.formatCurrencyValue($event)"
                                                    [type]="field.value_type" [formControlName]="field.db_column_name"
                                                    (keydown.enter)="submitInvoice()"
                                                    (change)="changeTextFieldValue(field)"
                                                    (keypress)="omit_special_char($event,field.valid_input_regexp);" />

                                                <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix
                                                    mat-icon-button
                                                    (click)="openAdvanceSearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields,field.predefined_table_column_name)">
                                                    <mat-icon>search</mat-icon>
                                                </button>
                                                <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                                    {{ field.field_name }} is required.
                                                </mat-error>
                                            </mat-form-field>

                                            <div *ngSwitchCase="'DROPDOWN'">
                                                <mat-form-field appearance="legacy" *ngIf="field.is_autocomplete != 1"
                                                    [style.width.%]="100">
                                                    <mat-label for="{field.field_name}">
                                                        {{ field.field_name }}
                                                        <span *ngIf="field.is_mandatory == 1"
                                                            class="field-mandatory">*</span>
                                                    </mat-label>
                                                    <mat-select [formControlName]="field.db_column_name"
                                                        (click)="searchText.focus()" (focus)="searchText.focus()"
                                                        (closed)="searchText.value=''"
                                                        (selectionChange)="changeDropdownFieldValue(field)"
                                                        [id]="field.field_name">
                                                        <input type="search" (keydown)="$event.stopPropagation()"
                                                            #searchText autocomplete="off" class="mat-select-search"
                                                            placeholder="Search {{field.field_name}}">
                                                        <mat-option [value]="option.id"
                                                            *ngFor="let option of field.options | listFilter:{'name':searchText.value}">
                                                            {{ option.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <button *ngIf="field.is_magnify_search == 1" mat-button matSuffix
                                                        mat-icon-button
                                                        (click)="$event.stopPropagation();openAdvanceSearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields)">
                                                        <mat-icon>search</mat-icon>
                                                    </button>
                                                    <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                                        {{ field.field_name }} is required.
                                                    </mat-error>
                                                </mat-form-field>

                                                <app-autocomplete matInput *ngIf="field.is_autocomplete == 1"
                                                    [field]="field" [formControlName]="field.db_column_name"
                                                    [defaultValue]="field.field_v"
                                                    (callOnAutoCompleteChangedEvent)="callOnAutoCompleteChangedEvent(field)">
                                                </app-autocomplete>
                                            </div>

                                            <mat-form-field *ngSwitchCase="'DATE'" [style.width.%]="100">
                                                <mat-label for="{field.field_name}">
                                                    {{ field.field_name }}
                                                    <span *ngIf="field.is_mandatory == 1"
                                                        class="field-mandatory">*</span>
                                                </mat-label>
                                                <input matInput readonly [min]="commonService.minDate"
                                                    [formControlName]="field.db_column_name" [matDatepicker]="picker"
                                                    (keydown.enter)="submitInvoice()" [id]="field.field_name" />
                                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                                <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                                    {{ field.field_name }} is required.
                                                </mat-error>
                                            </mat-form-field>

                                            <!-- <div *ngSwitchCase="'FILE'" [style.width.%]="100">
                          <mat-hint align="end">
                              Valid Files:{{invoiceDocValidFileExtensions.join('/ ')}} | Max. Size: {{invoiceDocFileSize}}MB
                          </mat-hint>
                          <span class="text-danger">*</span>
                          <mat-toolbar (click)="invFileUpload.click()">
                              <div class="form-group">
                                  <div class="input-group">
                                      <input type="text" class="form-control fileuploadinput" [formControlName]="field.db_column_name" readonly>
                                      <div class="input-group-btn">
                                          <span class="fileUpload btn blueupload">
                                              <span class="upl" id="upload">Upload Invoice
                                              </span>
                                          <input [attr.type]="fileControlType" class="upload up" id="up" #invFileUpload (change)="uploadFileEvt($event, field.db_column_name)" hidden accept="image/tif,image/tiff,application/pdf" />
                                          </span>
                                      </div>
                                  </div>
                              </div>
                          </mat-toolbar>
                      </div>  -->

                                            <mat-form-field *ngSwitchCase="'TEXTAREA'" [style.width.%]="100">
                                                <mat-label for="{field.field_name}">
                                                    {{ field.field_name }}
                                                    <span *ngIf="field.is_mandatory == 1"
                                                        class="field-mandatory">*</span>
                                                </mat-label>
                                                <textarea matInput #fieldComments
                                                    [formControlName]="field.db_column_name" rows="3" maxlength="500"
                                                    (change)="changeTextFieldValue(field)"
                                                    [id]="field.field_name"></textarea>
                                                <mat-hint align="end">
                                                    maximum {{ fieldComments.value?.length || 0 }} /500 charactors
                                                </mat-hint>
                                                <mat-error *ngIf="f[field.db_column_name].errors?.required">
                                                    {{ field.field_name }} is required.
                                                </mat-error>
                                            </mat-form-field>

                                            <div *ngSwitchCase="'CHECKBOX'" [style.width.%]="100">
                                                <mat-checkbox [formControlName]="field.db_column_name">
                                                    {{ field.field_name }}
                                                </mat-checkbox>
                                            </div>

                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="comment-box-main">
                        <div class="row cmnt_sec_h_100">
                            <div class="col-lg-5 cmnt_sec_h_100">
                                <label>Comments</label> <span class="comment_mandatory">*</span>
                                <div class="cmnt_textarea_sec" [ngClass]="isCommentExpand?'expanded_textarea':''">
                                    <span class="textarea_font_sec" title="Show list of restricted keywords"
                                        (click)="showModal(restrictedKeywordModal,'sm')">
                                        <img src="../../../assets/img/transaction/info.png" alt="Info">
                                    </span>
                                    <span class="expand_textarea_sec" title="Max/Min"
                                        (click)="isCommentExpand = !isCommentExpand">
                                        <img src="../../../assets/img/transaction/expand.png" alt="Expand">
                                    </span>
                                    <span class="textarea_editor_main_sec">
                                        <span class="words_count_limit">
                                            {{wordsTotal}}
                                        </span>
                                    </span>

                                    <textarea [formControlName]="invoiceComment" maxlength="1000"
                                        [(ngModel)]="strComments" (blur)="checkRestrictedKeywords(invoiceComment)"
                                        [class.invalid]="f.invoiceComment.errors && (f.invoiceComment.touched || submitted)"
                                        class="cmnt_textarea" (keyup)="function(strComments)"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-7">

                                <div class="row">
                                    <div class="col-lg-5">
                                    </div>
                                    <div class="col-lg-7">
                                        <div class="row">
                                            <div class="col-lg-7">
                                                <div class="input-field" *ngIf="Is_Next_queue_req">
                                                    <mat-form-field appearance="legacy" [style.width.%]="100">
                                                        <mat-label for="next_queue">Next Queue</mat-label>
                                                        <mat-select [formControlName]="nextQueue" required
                                                            id="next_queue">
                                                            <mat-option [value]="queue.process_id"
                                                                *ngFor="let queue of lstNextQueue">
                                                                {{queue.process_name}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <div class="col-lg-5">
                                                <a class="waves-effect waves-light btn cmnt_submit_btn"
                                                    (click)="submitInvoice()">
                                                    Update
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </div>

    <ng-template #restrictedKeywordModal let-modal>
        <div class="modal-content">
            <div class="modal-header model_center_header">
                <h5 class="modal-title">Keyword Replacement Chart</h5>
                <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true" class="model_close_btn">×</span>
                </button>
            </div>
            <div class="modal-body custom_modal_body">
                <div class="model_content">
                    <div class="table_section">
                        <div class="table-responsive tablecss mt10">
                            <table class="table custom_table">
                                <thead>
                                    <tr>
                                        <th>Keywords</th>
                                        <th>Auto Replacement</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of restrictedKeywords">
                                        <td>{{ item.restrict }}</td>
                                        <td>{{ item.replace }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <!-- <app-transaction-lite></app-transaction-lite> -->